import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";

class VenversProviders extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            providers: [],
            search:'',
            page: 1,
            total: 0,
            maxRecords: props.top,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
    }

    async getProviders(){
        var url = '/api/venvers/providers/list';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('internal', this.props.internal)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({providers: data, total: res.data.total});
    }

    handleChange(e){
        this.setState({providers: [], search: e.target.value, page: 1}, function () {
            this.getProviders();
        });
    }

    handleSwitch(i, id){
        let items = [...this.state.providers];
        let item = {...items[i]};
        item.active = (item.active)?false:true;
        items[i] = item;

        this.setState({providers: items}, function () {
            this.updateActive(id, items);
        });
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getProviders();
        });
    }

    async updateActive(id){
        var url = '/api/providers/update_active/'+id;
        const res = await axios.get(url);
        const data = res.data;
    }

  async componentDidMount() { 
    await this.getProviders();
  }

  render() {
    const { lang } = this.context; 
    return (
    <>
        <div className="card card-custom gutter-b my-5">
            <div className="card-header border-0 pt-6">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label font-weight-bolder font-size-h4 text-dark-75">

                        Venvers
                    </span>
                    
                    <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.invitados_en_total')}</span>
                </h3>
                <div className="card-toolbar">
                    <div>
                        <div className="input-icon">
                            <input
                                style={{width:'400px'}}
                                onChange={this.handleChange}
                                name="search"
                                type="text"
                                className="form-control"
                                placeholder={lang.get('messages.buscar_invitado')} />
                            <span>
                                <i className="flaticon2-search-1 text-primary icon-md"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body pt-5">
            <table className="table table-borderless table-vertical-center mb-0">
                <tbody> 
                {this.state.providers.map((o, i) => {
                    const providerId = o.person_id ?? o.persona?.id;

                    return (
                        <tr key={i}>
                        <td className="pl-0 py-5" style={{width: '1%'}}>
                            <div className="symbol symbol-40">
                                <div className={"symbol-label text-white font-weight-bolder bg-primary "  }>
                                { o.persona.fiscal_name[0].toUpperCase()}
                                </div>
                            </div>
                        </td>
                        <td className="text-left">
                        { this.props.internal == 1 &&
                            <a href={"/providers/"+providerId + "/internal"}>
                                <div className={"text-dark-75 font-weight-bolder mb-1 font-size-lg "  }>
                                     {o.persona.fiscal_name} <span className="text-muted font-weight-normal"> {o.persona.identity}: {o.persona.rfc}  </span>
                                </div>
                                <span className="text-muted">{lang.get('messages.tipo')}: {o.persona.person_type} { o.internal_company_identifier ?
                                    <>
                                        | No. {lang.get('messages.interno')}: {o.internal_company_identifier.internal_id } 
                                    </>
                                        :
                                        null
                                    }</span>
                            </a>
                        }
                        { this.props.internal == 0 &&
                            <a href={"/providers/"+providerId}>
                                <div className={"text-dark-75 font-weight-bolder mb-1 font-size-lg "}>
                                    {o.persona.fiscal_name} <span className="text-muted font-weight-normal">{o.persona.identity}: {o.persona.rfc} </span>
                                </div>
                                <span className="text-muted">{lang.get('messages.tipo')}: {o.persona.person_type} { o.internal_company_identifier ?
                                    <>
                                        | No. {lang.get('messages.interno')}: {o.internal_company_identifier.internal_id } 
                                    </>
                                        :
                                        null
                                    }</span>
                            </a>
                        }
                        </td>
                        <td className="text-left" style={{width: '1%'}}>
                       
                        </td>
                        <td className="text-right">
                        { this.props.internal == 1 &&
                            <a href={"/providers/"+providerId + "/internal"}>
                            <button className="btn btn-icon btn-light btn-xs">
                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                            </button>
                        </a>
                        }
                        { this.props.internal == 0 &&
                            <a href={"/providers/"+providerId}>
                            <button className="btn btn-icon btn-light btn-xs">
                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                            </button>
                        </a>
                        }
                        </td>
                    </tr>
                )})}
                </tbody>
                </table>
            </div>
            {this.state.total > this.state.maxRecords &&
                <SimplePagination
                updateCurrentPage={this.updateCurrentPage}
                currentPage={this.state.page}
                totalFiles={this.state.total}
                split={this.state.maxRecords} />
            }
        </div>
        </>
    );
    }
}

export default VenversProviders;
